<template>
  <div class="cart-head">
    <span>{{ $t('retailSale.cart.itemSpecs') }}</span>
    <span>{{ $t('retailSale.cart.qty') }}</span>
    <span>{{ $t('retailSale.cart.price') }}</span>
    <span></span>
  </div>
</template>

<script>
export default {
  name: 'CartTableHeader'
}
</script>

<style scoped src="../../styles/cart-table.css"></style>
